import { lazy, ReactNode, Suspense } from 'react'

const googleMapsLibraries = ['places']
const APIProvider = lazy(() =>
    import('@vis.gl/react-google-maps').then((module) => ({
        default: module.APIProvider,
    }))
)

const GoogleMapsProvider = ({ children }: { children: ReactNode }) => (
    <Suspense fallback={null}>
        <APIProvider
            apiKey={process.env.REACT_APP_GOOGLE_API_KEY as string}
            language="en-AU"
            libraries={googleMapsLibraries}
        >
            {children}
        </APIProvider>
    </Suspense>
)

export default GoogleMapsProvider
